import React, { useEffect, useRef, useState } from "react";
import UserSkillAddForm from "./components/UserSkillAddForm";
import { Switch, Route } from "react-router";
import SkillsHub from "./components/SkillsHub";
import ViewSkillSet from "./components/ViewSkillSet";
import SkillCollection from "./components/SkillCollection";
import {
  getTrendingSkills,
  getPopularSkills,
  getAllSkillSet,
  getSession,
} from "../../../redux/actions/skill";
import { useDispatch, useSelector } from "react-redux";
import EmptyLoader from "../../../components/emptyLoader";
import AgentHubHome from "./components/AgentHubHome";

const SkillStore = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const devices = useSelector((state) => state.skillReducer.devices);

  

  return (
    <React.Fragment>
        <UserSkillAddForm />
        {isLoading ? (
          <EmptyLoader />
        ) : (
          <Switch>
            <Route
              path="/dashboard/skill-store/skill-collection/:id"
              render={() => <SkillCollection />} //ViewAll Based on cardType
            />
            <Route
              path="/dashboard/skill-store/skill/:id"
              render={() => <ViewSkillSet />} //view Individual SkillSet
            />
            <Route path="/dashboard/skill-store" render={() => <SkillsHub />} />
          </Switch>
        )}
    </React.Fragment>
  );
};

export default SkillStore;
